import {BaseController} from "../../infrastructure/controllers/base-controller";
import {LocalStorageUtils} from "../../infrastructure/utils/local-storage.utils";
import {ACTION_TYPES, LOCAL_STORAGE_KEYS} from "../consts";
import {ActionHandler} from "../../infrastructure/handlers/action-handler";

export class RegisterNewUserHandler extends ActionHandler {
  type = ACTION_TYPES.registerNewUser;
  localStorageUtils: LocalStorageUtils;

  static injectables = [...ActionHandler.injectables, LocalStorageUtils];

  constructor(localStorageUtils: LocalStorageUtils) {
    super();

    this.localStorageUtils = localStorageUtils;
  }

  onInitialized(controller: BaseController) {
    super.onInitialized(controller);

    if(this.isNewUser === undefined) {
      this.localStorageUtils.set(LOCAL_STORAGE_KEYS.isNewUser, true);
    } else if(this.isNewUser){
      this.localStorageUtils.set(LOCAL_STORAGE_KEYS.isNewUser, false);
    }
  }

  get isNewUser(): Boolean {
    const isNewUser: Boolean = this.localStorageUtils.get(LOCAL_STORAGE_KEYS.isNewUser);

    return isNewUser;
  }
}
